/**
 * Rota "casa" de cada ambiente (E50.F2/ADR-0059).
 *
 * Fonte única da decisão de destino pós-login e dos redirects entre áreas:
 * `interno` mora na área do perito (/casos); `escritorio` e `banco` moram no
 * Portal do Cliente (/portal — Visão geral, decisão do owner na E50.F8.T01).
 * LoginPage e PortalGuard consomem daqui — nenhuma outra cópia da régua deve
 * existir.
 */
import type { Ambiente } from '@/lib/auth';
import type { PerfilData } from '@/lib/perfil';

export const PERITO_HOME_ROUTE = '/casos';
export const PORTAL_HOME_ROUTE = '/portal';

/**
 * E65.F3 (ADR-0069): destino de quem tem troca de senha pendente. Vale para os
 * dois ambientes — o gate é do servidor e não distingue área, então a tela que
 * o explica também não deve distinguir.
 */
export const TROCA_DE_SENHA_ROUTE = '/trocar-senha';

export function homeRouteForAmbiente(ambiente: Ambiente): string {
  return ambiente === 'interno' ? PERITO_HOME_ROUTE : PORTAL_HOME_ROUTE;
}

export function resolveHomeRoute(perfil: Pick<PerfilData, 'ambiente'>): string {
  return homeRouteForAmbiente(perfil.ambiente);
}
